<template>
  <div>
    <div class="row">
      <div class="col-10">
        <ProductionSummaryWidget :gridHeight="320" />
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="320">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/production/performance#tab-activepanel-list">Work In Progress Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/production/performance#tab-stagetask-list">Panel Stage Task Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/production/performance#tab-station-performance-graphs">Station Report</AnalyticsReportLink>            
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-8">
        <ProductionPanelBreakdownWidget :gridHeight="250" />
      </div>
      <div class="col-4">
        <ProductionScheduleWidget :gridHeight="250" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <ProductionStageSummaryWidget />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <ProductionStationSummaryWidget />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="700" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-schedule-stage">
              <i class="tabbedbox-tab-icon fas fa-tools"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-subtitle">Production Stage Schedule</div>
                <div class="tabbedbox-tab-title">Daily Panels</div>
              </div>
            </Tab>
            <Tab tabid="tab-stage-monthly-completion">
              <i class="tabbedbox-tab-icon fas fa-calendar-alt"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-subtitle">Production Stage Completed</div>
                <div class="tabbedbox-tab-title">Monthly Units</div>
              </div>
            </Tab>
            <Tab tabid="tab-station-toughyield">
              <i class="tabbedbox-tab-icon fas fa-hammer"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-subtitle">Toughening Station</div>
                <div class="tabbedbox-tab-title">Daily Bed Yields</div>
              </div>
            </Tab>
            <Tab tabid="tab-station-capacity">
              <i class="tabbedbox-tab-icon fas fa-tachometer-alt-fast"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-subtitle">Production Station</div>
                <div class="tabbedbox-tab-title">Daily Capacity</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-schedule-stage" class="tabpage-padding-2">
              <ProductionStageChartWidget :gridHeight="640" :embedded="true" />
            </TabPage>
            <TabPage tabid="tab-stage-monthly-completion" class="tabpage-padding-2">
              <ProductionStageMonthlyUnitsChartWidget :gridHeight="640" :embedded="true" />
            </TabPage>
            <TabPage tabid="tab-station-toughyield" class="tabpage-padding-2">
              <ProductionToughYieldChartWidget :gridHeight="640" :embedded="true" />              
            </TabPage>
            <TabPage tabid="tab-station-capacity" class="tabpage-padding-2">
              <ProductionDailyCapacityChartWidget :gridHeight="640" :embedded="true" />              
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import ProductionSummaryWidget from '@/modules/intelligence/dashboardWidgets/productionSummaryWidget'
import ProductionPanelBreakdownWidget from '@/modules/intelligence/dashboardWidgets/productionPanelBreakdownWidget'
import ProductionStageSummaryWidget from '@/modules/intelligence/dashboardWidgets/productionStageSummaryWidget'
import ProductionStationSummaryWidget from '@/modules/intelligence/dashboardWidgets/productionStationSummaryWidget'
import ProductionScheduleWidget from '@/modules/intelligence/dashboardWidgets/productionScheduleWidget'
import ProductionStageChartWidget from '@/modules/intelligence/dashboardWidgets/productionStageChartWidget'
import ProductionStageMonthlyUnitsChartWidget from '@/modules/intelligence/dashboardWidgets/productionStageMonthlyUnitsChartWidget'
import ProductionToughYieldChartWidget from '@/modules/intelligence/dashboardWidgets/productionToughYieldChartWidget'
import ProductionDailyCapacityChartWidget from '@/modules/intelligence/dashboardWidgets/productionDailyCapacityChartWidget'
import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsProductionDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,
    ProductionSummaryWidget,
    ProductionPanelBreakdownWidget,
    ProductionStageSummaryWidget,
    ProductionStationSummaryWidget,
    ProductionScheduleWidget,
    ProductionStageChartWidget,
    ProductionStageMonthlyUnitsChartWidget,
    ProductionToughYieldChartWidget,
    ProductionDailyCapacityChartWidget,
    ReportFilterPopover,
    ReportDateRangeSelect
  },
  data() {
    return {
      
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  methods: {
    
  }
  
}
</script>